<script setup lang="ts">
import { onClickOutside } from '@vueuse/core';
import { computed, ref } from 'vue';

const showButtonGroup = ref<boolean>(false);
const toggleButtonGroupVisibility = (event: MouseEvent) => {
  event.stopPropagation();
  showButtonGroup.value = !showButtonGroup.value;
};

const target = ref<HTMLDivElement | null>(null);
onClickOutside(target, () => {
  if (showButtonGroup.value) {
    showButtonGroup.value = false;
  }
});

const colorDots = computed(() => ({
  'text-default': !showButtonGroup.value,
  'text-default-tertiary': showButtonGroup.value
}));

const menuPosition = computed(() => {
  if (!target.value) {
    return { top: '0px', left: '0px' };
  }

  const rect = target.value.getBoundingClientRect();
  return {
    top: `${rect.bottom + 8}px`,
    left: `${rect.right - 208}px`
  };
});
</script>

<template>
  <div
    ref="target"
    data-testid="dotted-menu-button"
    class="relative flex items-center justify-center cursor-pointer w-10 h-10"
    @click="toggleButtonGroupVisibility"
  >
    <div
      :class="colorDots"
      class="dots pl-2 text-3xl flex items-center justify-center w-full h-full border border-gray-300 border-t-0 border-l border-r-0 border-b-0 hover:text-default-tertiary"
    />
    <div
      v-if="showButtonGroup"
      class="fixed z-9999 w-52 bg-white shadow-lg border border-border-main-primary rounded-lg"
      :style="menuPosition"
    >
      <slot />
    </div>
  </div>
</template>

<style scoped>
.dots::after {
  content: '\2807';
}
</style>
